import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BrandingCtx = createContext(null);

const FALLBACK = {
  app_name: "Portale Ordini B2B",
  logo_main_url: null,
  logo_compact_url: null,
  favicon_url: null,
  color_primary: "#0F4C81",
  color_secondary: "#F2A65A",
  color_accent: "#1D6E5F",
  login_background_url: null,
  banner_urls: {},
  company_info: {},
  contacts: {},
};

/**
 * Loads branding from the backend once at boot. Fallback silently if API not reachable.
 * ADMIN can PUT /api/branding to update at runtime — page reload picks it up.
 */
export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    axios.get(`${API}/api/branding`).then((r) => {
      setBranding({ ...FALLBACK, ...r.data });
    }).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  useEffect(() => {
    if (branding?.app_name) document.title = branding.app_name;
    if (branding?.favicon_url) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = branding.favicon_url;
    }
  }, [branding]);

  return (
    <BrandingCtx.Provider value={{ branding, setBranding, loaded }}>
      {children}
    </BrandingCtx.Provider>
  );
}

export const useBranding = () => useContext(BrandingCtx);
